import React from 'react';
import { useReveal } from '../lib/useReveal';
const PAIN_POINTS = ['Querés aprender Reiki pero no sabés por dónde empezar.', 'Probaste cursos aislados que no te dieron una formación completa.', 'Sentís que podrías ayudar a otras personas pero todavía no te animás.', 'Buscás una formación seria y bien organizada.', 'Querés crecer espiritual y personalmente.', 'Te gustaría comenzar un nuevo camino profesional.'];
export function ProblemSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#1A1625] py-20 md:py-32 px-5 sm:px-6 relative overflow-hidden" data-id="element-332">
      <div className="container mx-auto max-w-5xl relative z-10" data-id="element-333">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-334">
          <div className="text-center mb-16 md:mb-20" data-id="element-335">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight text-white max-w-3xl mx-auto" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-336">
              ¿Te sentís identificado con alguna de estas situaciones?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6" data-id="element-337">
            {PAIN_POINTS.map((point, idx) => <div key={idx} className="bg-[#241F33] rounded-2xl p-6 md:p-8 shadow-lg flex items-start gap-4 border border-[#342D45] transition-all duration-300 hover:border-[#D4AF37]/30 hover:bg-[#2A243B]" data-id="element-338">
                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-[#1A1625] flex items-center justify-center border border-[#342D45] text-[#D4AF37] font-bold text-sm" data-id="element-339">
                  ✕
                </span>
                <p className="text-white/90 text-base md:text-lg leading-relaxed pt-0.5" data-id="element-340">
                  {point}
                </p>
              </div>)}
          </div>

          <div className="mt-16 text-center" data-id="element-341">
            <p className="text-[#D4AF37] font-serif italic text-xl md:text-2xl font-medium" data-id="element-342">
              Miles de personas comenzaron exactamente desde ese mismo lugar.
            </p>
          </div>
        </div>
      </div>
    </section>;
}